export default __webpack_public_path__ + "static/media/product-icon.b68ada72.svg";